export default {
  eachExcludes: ['eachExcludes'],

  name (value) {
    let name = null

    this.each((val, item) => {
      if (val === value) {
        name = item
        return false
      }

      return true
    })

    return name
  },

  each (callback) {

    for (const item in this) {

      // eslint-disable-next-line no-prototype-builtins
      if (this.hasOwnProperty(item)) {

        if (typeof this[item] !== 'function' && this.eachExcludes.indexOf(item) < 0) {

          if (callback.call(this, this[item], item) === false) {

            break
          }
        }
      }
    }
  },

  values () {
    const values = []

    this.each(v => values.push(v))

    return values
  },

  title (value) {
    return this.name(value)
  },

  options (empty = false) {

    const options = []

    if (empty) {
      options.push({
        value: 0,
        label: ''
      })
    }

    this.each((val) => {

      options.push({
        value: val,
        label: this.title(val)
      })

    })

    return options
  }
}
